(function () {
  console.log("function starting........................");

  const STORAGE_KEY = 'cart_credits_toggle_state';

  function setupCreditsToggle() {
    const toggleInput = document.getElementById('use-credits-toggle');
    const creditsUsage = document.getElementById('cart__credits-usage');
    const defaultBtn = document.getElementById('default-checkout-btn');
    const customBtn = document.getElementById('custom-order-btn');

    if (!toggleInput || !creditsUsage) return;

    const toggleLabel = toggleInput.closest('.cart__credits-toggle-label');

    if (toggleInput._creditsToggleHandler) {
      toggleInput.removeEventListener('change', toggleInput._creditsToggleHandler);
    }

    function formatPrice(price) {
      return Number(price || 0).toFixed(2);
    }

    // function getCreditDeduction() {
    //   const creditEl = document.getElementById('credits-deduction');
    //   const value = creditEl?.textContent?.trim() || '0';
    //   return parseInt(value, 10) || 0;
    // }

    function getCreditDeduction() {
      return Number(window.customerCredits || 0);
    }

    function getItemQty(item) {
      const qty =
        item.getAttribute('total-qty') ||
        item.querySelector('.cart_item_qty')?.textContent ||
        '1';

      return parseInt(qty, 10) || 1;
    }

    function getItemLinePrice(item) {
      const priceEl = item.querySelector('.regular__price');
      if (!priceEl) return 0;

      const rawPrice =
        priceEl.getAttribute('item-price') ||
        priceEl.getAttribute('value') ||
        priceEl.textContent ||
        '0';

      return parseFloat(rawPrice.replace(/[^0-9.]/g, '')) || 0;
    }

    function getItemUnitPrice(item) {
      const qty = getItemQty(item);
      const linePrice = getItemLinePrice(item);

      return qty > 0 ? linePrice / qty : linePrice;
    }

    function getCartTotal() {
      const totalEl = document.querySelector(
        'span.cart__summary-item.cart__total .cart__total-value'
      );

      if (!totalEl) return 0;

      const rawTotal =
        totalEl.getAttribute('cart-total-pice') ||
        totalEl.getAttribute('value') ||
        totalEl.textContent ||
        '0';

      return parseFloat(rawTotal.replace(/[^0-9.]/g, '')) || 0;
    }

    function resetPrices() {
      document.querySelectorAll('.cart-item-card').forEach(function (item) {
        item.classList.remove('credit-price-enabled');
        item.removeAttribute('data-credit-applied-qty');

        const priceWrap = item.querySelector('.cart-item-card__price');
        if (!priceWrap) return;

        const discountPrice = priceWrap.querySelector('.discount_price');
        const regularPrice = priceWrap.querySelector('.regular_price');

        if (discountPrice) {
          discountPrice.style.display = 'none';

          if (discountPrice.getAttribute('data-original-html')) {
            discountPrice.innerHTML = discountPrice.getAttribute('data-original-html');
          }
        }

        if (regularPrice) {
          regularPrice.style.display = '';
        }
      });
    }

    function applyCreditPrices() {
      resetPrices();

      let remainingCredits = getCreditDeduction();
      console.log("remainingCredits ...........1111111111111111",remainingCredits)

      if (!toggleInput.checked || remainingCredits <= 0) return;

      const eligibleItems = document.querySelectorAll('.cart-item-card[data-new-release="true"]');

      eligibleItems.forEach(function (item) {
        if (remainingCredits <= 0) return;

        const itemQty = getItemQty(item);
        const appliedQty = Math.min(itemQty, remainingCredits);
        const unitPrice = getItemUnitPrice(item);
        const appliedPrice = unitPrice * appliedQty;

        item.setAttribute('data-credit-applied-qty', appliedQty);

        const priceWrap = item.querySelector('.cart-item-card__price');
        if (!priceWrap) return;

        const discountPrice = priceWrap.querySelector('.discount_price');
        const regularPrice = priceWrap.querySelector('.regular_price');

        if (discountPrice && !discountPrice.getAttribute('data-original-html')) {
          discountPrice.setAttribute('data-original-html', discountPrice.innerHTML);
        }

        item.classList.add('credit-price-enabled');

        if (discountPrice) {
          discountPrice.style.display = '';

          if (appliedQty >= itemQty) {
            discountPrice.innerHTML = '$0.00';
            discountPrice.setAttribute('value', '$0.00');
          } else {
            discountPrice.innerHTML = '$' + formatPrice(appliedPrice);
            discountPrice.setAttribute('value', '$' + formatPrice(appliedPrice));
          }
        }

        if (regularPrice) {
          regularPrice.style.display = '';
        }

        remainingCredits -= appliedQty;
      });
    }

    // function getCreditItemsTotal() {
    //   const items = document.querySelectorAll(
    //     '.cart-item-card[data-credit-applied-qty][data-new-release="true"]'
    //   );

    //   let total = 0;
    //   let usedCredit = 0;

    //   items.forEach(function (item) {
    //     const appliedQty =
    //       parseInt(item.getAttribute('data-credit-applied-qty') || '0', 10) || 0;

    //     if (appliedQty <= 0) return;

    //     const unitPrice = getItemUnitPrice(item);

    //     total += unitPrice * appliedQty;
    //     usedCredit += appliedQty;
    //   });

    //   $('.cart__credits-usage-label span').text(usedCredit);

    //   return total;
    // }

    async function saveUseCreditsState(value) {

      // console.log("window.Shopify?.shop", window.Shopify?.shop);
      // console.log("window.customer_id", window?.customer_id);
      // console.log("value", value);

      try {
        const response = await fetch(
          "https://app.thevoxspot.com/api/cart-credits-toggle",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              shop:
                window.Shopify?.shop ||
                window.shopDomain ||
                "edditproductions.myshopify.com",

              customerId: String(window?.customer_id || ""),

              value: value,
            }),
          }
        );

        const data = await response.json();

        if (!data.success) {
          console.error("❌ Use credits save failed:", data);
          return false;
        }

        console.log("✅ Use credits saved:", data.value);

        return true;
      } catch (error) {
        console.error("❌ Use credits save error:", error);
        return false;
      }
    }


    function getCreditItemsTotal() {
 

      // $.ajax({
      //     url: window.location.href,
      //     type: 'GET',

      //     success: function (response) {
      //       const $response = $(response); 

      //       const newCount = $response.find('#cart-drawer-heading').text();
      //       // $('#cart-drawer-heading').text(newCount);

      //       const newTotal = $response.find('[data-cart-subtotal]').text();
      //       $('[data-cart-subtotal]').text(newTotal);

      //       const newTotalAttr = $response
      //         .find('.cart__total-value')
      //         .attr('cart-total-pice');

      //       $('.cart__total-value').attr('cart-total-pice', newTotalAttr);

      //       const newTotalValue = $response.find('.cart__total-value').attr('value');

      //       $('.cart__total-value').attr('value', newTotalValue);

      //       if ($('#use-credits-toggle').is(':checked')) {

      //         // let totalPrice = 0;

      //         // document
      //         //   .querySelectorAll(
      //         //     '.cart-item-card.credit-price-enabled[data-new-release="true"]'
      //         //   )
      //         //   .forEach(function (item) {
      //         //     const priceEl = item.querySelector('.regular__price');
      //         //     if (!priceEl) return;

      //         //     const rawPrice = priceEl.getAttribute('item-price') || '0';
      //         //     const itemPrice = parseFloat(rawPrice.replace(/,/g, '')) || 0;

      //         //     totalPrice += itemPrice;
      //         //   });

      //               let totalPrice = 0;

      //               const totalCredits = Number(getCreditDeduction() || 0);

      //               let remainingCredits = totalCredits;
      //               const items = document
      //                 .querySelectorAll(
      //                   '.cart-item-card.credit-price-enabled[data-new-release="true"]'
      //                 )

      //               items.forEach(function (item) {

      //                 const priceEl = item.querySelector('.regular__price');
      //                 if (!priceEl) return;

      //                 const rawPrice = priceEl.getAttribute('item-price') || '0';

      //                 // full line price
      //                 const linePrice = parseFloat(rawPrice.replace(/,/g, '')) || 0;

      //                 const qty = Number(item.getAttribute('total-qty') || 1);

      //                 // per qty price
      //                 const unitPrice = linePrice / qty;

      //                 // kitni qty free hogi
      //                 const discountedQty = Math.min(qty, remainingCredits);

      //                 // sirf discount amount calculate
      //                 totalPrice += discountedQty * unitPrice;

      //                 remainingCredits -= discountedQty;

      //                 console.log({
      //                   qty,
      //                   linePrice,
      //                   unitPrice,
      //                   discountedQty,
      //                   totalPrice
      //                 });

      //               });


      //         const totalCart =
      //           parseFloat((newTotalAttr || '0').replace(/,/g, '')) || 0;

      //         $('.credit_discount_apply .credit_discount span').html(
      //           totalPrice.toLocaleString('en-IN', {
      //             minimumFractionDigits: 2,
      //             maximumFractionDigits: 2,
      //           })
      //         );

      //         $('.credit_discount_apply .total_credit_amount span').html(
      //           (totalCart - totalPrice).toLocaleString('en-IN', {
      //             minimumFractionDigits: 2,
      //             maximumFractionDigits: 2,
      //           })
      //         );

      //         const usedCredit = $(
      //           '.cart-item-card.credit-price-enabled[data-new-release="true"]'
      //         ).length;

      //         $('.cart__credits-usage-label span').text(usedCredit);
      //       }
      //     },

      //     error: function (xhr, status, error) {
      //       console.log(error);
      //     },
      //   });

      console.log("getCreditItemsTotal.............")

      const items = document.querySelectorAll('.cart-item-card.credit-price-enabled[data-new-release="true"]');

      let total = 0;
      const totalCredits = Number(getCreditDeduction() || 0);
      console.log("totalCredits....................222222222222222",totalCredits)
      let remainingCredits = totalCredits;

      let totalQty = 0

      items.forEach(function (item) {
        const priceEl = item.querySelector('.regular__price');
        if (!priceEl) return;

        const rawPrice = priceEl.getAttribute('item-price') || '0';

        // full line price
        const linePrice = parseFloat(rawPrice.replace(/,/g, '')) || 0;

        const qty = Number(item.getAttribute('total-qty') || 1);

        // per qty price
        const unitPrice = linePrice / qty;

        // kitni qty free hogi
        const discountedQty = Math.min(qty, remainingCredits);

        // sirf discount amount calculate
        total += discountedQty * unitPrice;

        remainingCredits -= discountedQty
      });

      console.log("total",total)

      let UsedCredit = 0;

      $('.cart-item-card.credit-price-enabled[data-new-release="true"]').each(function () {
        const qty = Number($(this).attr('total-qty') || 1);
        UsedCredit += qty;
      });

      $('.cart-item-card').each(function () {
        const qty = Number($(this).attr('total-qty') || 1);
        totalQty += qty;
      });

      console.log("totalQty....................",totalQty)

      // actual usable credits
      UsedCredit = Math.min(UsedCredit, totalCredits);

      console.log("getCreditItemsTotal UsedCredit ................",UsedCredit)

      $('.cart__credits-usage-label span').text(UsedCredit);

      $('#cart-drawer-heading').text(`Cart (${totalQty})`);

      const creditsEl = document.getElementById('credits-deduction');

      if (creditsEl) {
        creditsEl.innerHTML = `${remainingCredits} <strong>credits remaining</strong>`;
      }

      return total;
    }

    function updateTotals() {
      const totalPrice = getCreditItemsTotal();
      const totalCart = getCartTotal();

      const discountEl = document.querySelector(
        '.credit_discount_apply .credit_discount span'
      );

      const totalAmountEl = document.querySelector(
        '.credit_discount_apply .total_credit_amount span'
      );

      if (discountEl) {
        discountEl.innerHTML = formatPrice(totalPrice);
      }

      if (totalAmountEl) {
        totalAmountEl.innerHTML = formatPrice(totalCart - totalPrice);
      }
    }

    toggleInput._creditsToggleHandler = function () {
      if (this.checked) {
        localStorage.setItem(STORAGE_KEY, 'true');
        saveUseCreditsState(true);

        creditsUsage.style.display = 'block';

        if (toggleLabel) toggleLabel.classList.add('credits-toggle-active');

        if (defaultBtn) defaultBtn.style.display = 'none';
        if (customBtn) customBtn.style.display = 'block';

        applyCreditPrices();

        const discountApply = document.querySelector('.credit_discount_apply');
        const cartSubtotal = document.querySelector('.cart_subtotal');
        const cartRegularTotal = document.querySelector('.cart_regular_total');

        if (discountApply) discountApply.style.display = 'block';
        if (cartSubtotal) cartSubtotal.style.display = 'block';
        if (cartRegularTotal) cartRegularTotal.style.display = 'none';

        updateTotals();

        const cartTotalValue = document.querySelector('.cart__total .cart__total-value');
        if (cartTotalValue && cartTotalValue.getAttribute('value')) {
          cartTotalValue.innerHTML = cartTotalValue.getAttribute('value');
        }
      } else {
        localStorage.setItem(STORAGE_KEY, 'false');
        saveUseCreditsState(false);

        creditsUsage.style.display = 'none';

        if (toggleLabel) toggleLabel.classList.remove('credits-toggle-active');

        if (defaultBtn) defaultBtn.style.display = 'block';
        if (customBtn) customBtn.style.display = 'none';

        resetPrices();

        const discountApply = document.querySelector('.credit_discount_apply');
        const cartSubtotal = document.querySelector('.cart_subtotal');
        const cartRegularTotal = document.querySelector('.cart_regular_total');

        if (discountApply) discountApply.style.display = 'none';
        if (cartSubtotal) cartSubtotal.style.display = 'none';
        if (cartRegularTotal) cartRegularTotal.style.display = 'block';

        $('.cart__credits-usage-label span').text(0);
      }
    };

    toggleInput.addEventListener('change', toggleInput._creditsToggleHandler);

    const savedState = localStorage.getItem(STORAGE_KEY);
    toggleInput.checked = savedState === 'true';

    toggleInput._creditsToggleHandler.call(toggleInput);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCreditsToggle);
  } else {
    setupCreditsToggle();
  }

  document.addEventListener('cart:content:refreshed', function () {
    setTimeout(setupCreditsToggle, 50);
  });

  document.addEventListener('cart:updated', function () {
    setTimeout(setupCreditsToggle, 50);
  });

})();